//In your react App.js or yourComponent.js file add these lines to import

import React from 'react';
import QuestionnaireForm from '../Common/QuestionnaireForm';
import * as Survey from "survey-react";
import { getInstance } from '../../services/dataService';

const AUTO_SAVE_INTERVAL = 1000 * 60  * 5 //5 minutes

class QuestionnaireFormUILoad extends QuestionnaireForm {



    constructor(props) {
        super(props);
    }

    get currentInstanceId() {
        return this.props.match.params.formId;
    }

    componentDidMount() {
        if(this.currentInstanceId)
            this.loadPage(this.currentInstanceId);

    }

    componentDidUpdate(prevProps) {

        const { match: { params: { formId: lastInstanceId } } } = prevProps;

        if (this.currentInstanceId !== lastInstanceId)
            this.loadPage(this.currentInstanceId);
    }


    componentWillUnmount(){
        if(this.intervalId)
            clearInterval(this.intervalId);
      }
      

    loadPage = async (id) => {
        this.clearIntervalIfNecessary();

        this.state = { loading: true };
        const formAndResponses = await getInstance(id);
        this.state = { loading: false };
        this.model = new Survey.Model(formAndResponses.form);
                
        this.setFormData(formAndResponses);
                        
        this.setState({ loading: false, isComplete: false });
        this.intervalId = setInterval(()=>this.performAutoSave(), AUTO_SAVE_INTERVAL);

    };




}
export default QuestionnaireFormUILoad;